/**
 * Return 페이제서 반품이 가능한 주문 정보 조회 API
 * common - https://unchjbztzqx7ng7ehlap4khwgy0lkbao.lambda-url.ap-northeast-2.on.aws/ // common_get_returnable_fulfillments
 */
import type { Metafield } from "@shopify/hydrogen-react/storefront-api-types";

export interface IFetchReturnableOrder {
  order: IOrder;
  returnableFulfillmentLineItems: IReturnableFulfillmentLineItem[];
}

export const fetchReturnableOrder = async ({
  storeName,
  domain = "",
  orderId,
  customerId,
}: {
  storeName: string;
  domain?: "kr" | "intl" | "";
  orderId: string;
  customerId: string;
}): Promise<IFetchReturnableOrder | undefined> => {
  const lambdaUrl = "https://unchjbztzqx7ng7ehlap4khwgy0lkbao.lambda-url.ap-northeast-2.on.aws/";

  try {
    const response = await fetch(lambdaUrl, {
      method: "POST",
      body: JSON.stringify({ orderId, storeName, domain, customerId }),
    }).then((res) => res);

    if (response.status === 200) {
      return (await response.json()) as IFetchReturnableOrder;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};

export interface IOrder {
  createdAt: string;
  name: string;
  country: string;
  returnStatus: string;
  totalOrderItemCount: number;
  totalReturnedItemCount: number;
}
export interface IReturnableFulfillmentLineItem {
  fulfillmentLineItem: {
    id: string;
    quantity: number;
    weight?: {
      unit: string;
      value: number;
    };
    originalTotalSet: {
      shopMoney: {
        amount: string;
      };
    };
    discountedTotalSet: {
      shopMoney: {
        amount: string;
      };
    };
    lineItem: ILineItem;
  };
  quantity: number;
}

export interface ILineItem {
  currentQuantity: number;
  nonFulfillableQuantity: number;
  originalTotalSet: {
    shopMoney: {
      amount: string;
    };
  };
  discountedTotalSet: {
    shopMoney: {
      amount: string;
    };
  };
  discountAllocations: IDiscountAllocation[];
  id: string;
  name: string;
  title: string;
  image: {
    width: number;
    url: string;
    height: number;
  } | null;
  product: {
    handle: string;
    id: string;
    status: string;
    tags: string[];
    title: string;
    vendor: string;
    thumbnailImages?: Metafield;
  };
  quantity: number;
  variant: IVariant | null;
  variantTitle: string;
  vendor: string;
}

export interface IVariant {
  availableForSale: boolean;
  compareAtPrice: string;
  displayName: string;
  id: string;
  image: {
    width: number;
    url: string;
    height: number;
  } | null;
  price: string;
  selectedOptions: {
    name: string;
    value: string;
  }[];
}

export interface IDiscountAllocation {
  allocatedAmount: IShopMoney;
}

interface IShopMoney {
  amount: string;
}
